import React, { useEffect, useState } from "react";
import { sortProductSizes } from "utils/UtilityFuncs";

export default function QuickViewProductSizes({ selectedProduct }) {
  /*   All States
   ********************************************* */
  const [allSizes, setAllSizes] = useState(null);

  /*   All Functions
   ********************************************* */

  // Delegates to the shared helper: the old local copy sorted the array
  // IN PLACE, mutating React state, and blew up on entries with no sortId.
  const sortArrBySortId = (arr) => sortProductSizes(arr);

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      setAllSizes(
        selectedProduct?.productSizes
          ? typeof selectedProduct?.productSizes === "string"
            ? JSON.parse(selectedProduct?.productSizes)
            : selectedProduct?.productSizes
          : [],
      );
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedProduct]);
  return (
    <div className="h-100 d-flex flex-column">
      <div
        className="bg-white shadow px-3 mb-2 me-2 d-flex flex-column py-2 flex-grow-1"
        style={{ borderRadius: 15, minHeight: 0 }}
      >
        <div style={{ overflowY: "auto", flex: "1 1 auto", minHeight: 0 }}>
          <div className="table-responsive  ">
            <table className="table ">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Size
                  </th>
                  <th scope="col" className="text-center">
                    Quantity
                  </th>
                  <th scope="col" className="text-center">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortArrBySortId(allSizes)?.map((item, i) => (
                  <tr key={i}>
                    <td className="py-0 ">{item?.size?.toUpperCase()}</td>
                    <td className="py-0 text-center">{item?.quantity}</td>
                    <td className="py-0 text-center">
                      $ {parseFloat(item?.price).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="d-flex">
        <div
          className="d-flex justify-content-evenly flex-grow-1 py-1 align-items-center bg-white shadow me-2"
          style={{ borderRadius: 15 }}
        >
          <div>
            Total Qty
            <span className="border ms-1 px-2">
              {parseFloat(selectedProduct?.totalQuantity)}
            </span>
          </div>
          <div>
            Total Price
            <span className="border ms-1 px-2">
              $ {parseFloat(selectedProduct?.totalPrice).toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
